export default {
  fullBindingTitle1025: 'NFC - 1025 FULL Tagging',
  nddcBindingTitle1025: 'NFC - 1025 NDDC Tagging',
  fullBindingTitle1027: 'NFC - 1027 FULL Tagging',
  nddcBindingTitle1027: 'NFC - 1027 NDDC Tagging',
  bindingTitle: 'RFID - NDDC Binding',
  unbindByCartonTitle: 'RFID - NDDC Unbind by Carton',
  unbindByPieceTitle: 'RFID - NDDC Unbind by Piece',
  unbindBySoTitle: 'RFID - NDDC Unbind by SO',
  so: 'SO',
  unbindByCartonSuccess: 'Unbind Successfull',
  bindByCartonSuccess: 'Bind Successfull',
  notChannel: 'Please register your RF device with Channel info.',
  notRegisterTitle: 'Device Not Registered',
  notRegister:
    'This RF Device is not registered in TraceHub. Please register with your device code and Mac address before next login.',
  cartonNo: 'Carton No',
  upc: 'UPC',
  unknownSku: 'Unknown SKU',
  rfidEpc: 'RFID EPC',
  qrCode: 'QR Code',
  salesOrder: 'Sales Order',
  switchToQrCode: 'Switch To QR Code',
  switchToRfidEpc: 'Switch To RFID EPC',
  bindResult: 'Bind Result',
  rfid: 'RFID',
  qr: 'QR',
  sku: 'SKU',
  skuScanCount: 'SKU Scan Count',
  unitScanCount: 'Unit Scan Count',
  nextCarton: 'Next Carton',
  nextEpc: 'Next EPC',
  clear: 'Clear',
  errorcode_30007: 'The binding of the carton is complete.',
  errorcode_30008: 'The carton does not exist in the wave run list.',
  errorcode_30009: 'The SKU does not exist in this carton.',
  errorcode_30010: 'This product in this carton has reached its binding request limit.',
  errorcode_30011: 'The EPC cannot be decoded into UPC. Please scan the QR Code.',
  errorcode_30013: `This <span class='textDecoration'>EPC</span>
    has already been bound with <span class='link_name_dashboard_error'>current carton</span>.
    Please scan the <span class='textDecoration'>QR Code</span>.`,
  errorcode_30012: `This EPC has already been bound with
    <span class='link_name_dashboard_error'> another carton</span>.
    Please scan the QR Code.`,
  errorcode_30018: `This <span class='textDecoration'>QR Code</span>
    has already been bound with <span class='link_name_dashboard_error'>current carton</span>.
    Please scan the <span class='textDecoration'>EPC</span>.`,
  errorcode_30017: `This QR Code has already been bound with
    <span class='link_name_dashboard_error'> another carton</span>.
    Please scan the EPC.`,
  errorcode_30014: 'UPC unmatched.',
  errorcode_30015: 'Product master data is not exist.',
  errorcode_30016: 'Unconfigured RF device. Please contact RFID Admin team.',
  errorcode_7006: 'No EPC info collected, please scan again.',
  errorcode_9: 'The item is too close to surrounding items (<10 cm). Please adjust and rescan.',
  errorcode_10:
    'The carton binding is not complete. Please confirm again whether to scan the next carton.SKU Not Bound: ',
  errorcode_11: 'The product binding is not complete. Please confirm again whether to scan the next product.',
  cartonNoEmpty: 'Carton No cannot be empty. Please scan or input the Carton No.',
  errorcode_30001: 'Carton number cannot be empty.',
  errorcode_30002: 'The carton does not exist in T-hub.',
  errorcode_30003: 'The binding of the carton is incomplete.',
  errorcode_30004: 'At least one of epc and qrCode cannot be empty.',
  errorcode_30005: 'The product does not exist in T-hub.',
  errorcode_30006: 'The product is not bound.',
  readEpcErr: 'Unable to recognize middleware. Please start middleware in desktop app "RfidDemo"',
  multipleEpc: 'The item is too close to surrounding items (<10 cm). Please adjust and rescan.',
  'bound-1': 'Not Bound',
  bound0: 'Not Bound',
  bound1: 'Bound',
  bound2: 'Unbind',
  boundCarton0: 'Not Bound',
  boundCarton1: 'Binding In Progress',
  boundCarton2: 'Bound',
  boundCarton3: 'Unbind',
  boundCarton4: 'Force Binding',
  statusSignal: 'Carton Status',
  itemSstatus: 'Status',
  productCode: 'Product Code',
  backFirstPage: 'Return',
  back: 'Return',
  rfIbScanningTitle1025: '1025 RFID Carton Scan - Inbound',
  rfObScanningTitle1025: '1025 RFID Carton Scan – Outbound',
  rfIbScanningTitle1027: '1027 RFID Carton Scan – Inbound',
  rfObScanningTitle1027: '1027 RFID Carton Scan - Outbound',
  menu: 'Main Menu',
  openCarton: 'Open Carton',
  reScan: 'Re-Scan',
  scanEpcs: 'Scan EPCs ',
  asnQty: 'ASN Qty',
  giQty: 'GI Qty',
  systemQty: 'System Scan Qty',
  latestScanResult: 'Latest System Scan Result:',
  latestValidationScanResult: 'Latest System Validation Result:',
  scanResult: 'Current Carton Scan Result:',
  validationResult: 'Current Carton Validation Result:',
  scanDataResult: 'Scan Result:',
  comfirmScanResult: 'After unpacking and inspection, the confirmed result of the box is:',
  productShortage: 'Product Shortage',
  productOverage: 'Product Overage',
  specialProduct: 'Special Product',
  manualUnitScan: 'Manual Unit Scan',
  accurate: 'Accurate',
  Unexpected: 'Unexpected',
  epcShortage: 'EPC Shortage',
  epcOverage: 'EPC Overage',
  upcMismatched: 'UPC Mismatched',
  manualConfirm: 'Manual Confirm',
  newCarton: 'New Carton',
  productShortageMsg:
    'Please confirm again that the manual inspection results of this Carton indicate <strong>"Product shortage"</strong>. After submission, the system will automatically proceed to the nextCarton.',
  productOverageMsg:
    'Please confirm again that the manual inspection results of this Carton indicate <strong>"Product overage"</strong>. After submission, the system will automatically proceed to the next Carton.',
  specialProductMsg:
    'Please confirm again that the manual inspection results of this Carton indicate <strong>"Special product"</strong>. After submission, the system will automatically proceed to the next Carton.',
  scanWarnMsg: 'Please press and hold the trigger to start scanning, release the trigger to stop scanning',
  relabel: 'Relabel',
  submit: 'Submit',
  backPage: 'Back',
  manualAccurate: 'Accurate',
  epcUpdate: 'EPC Updated',
  unitCount: 'Unit Count',
  manualScanTip:
    "Please confirm that the product SKU is correct and that there are no other interconnected products near by before scanning the product's QR code and UPC barcode. If the QR code cannot be scanned, only the product's UPC barcode can be scanned. ",
  confirm: 'Confirm',
  cancel: 'Cancel',
  invalidUpc: 'Invalid UPC format, please try again. Correct UPC format should be 00197863493015.',
  invalidQrCode:
    'Invalid QR Code format, please try again. Correct QR Code format should be HTTPS://QR.NIKE.COM/04B5Z1S0ERWR1.',
  upcUnmatched: 'UPC Unmatched.',
  physicalSkuCorrect: 'Physical SKU Correct',
  physicalSkuInCorrect: 'Physical SKU Incorrect',
  manualInCorrectTip:
    "Please confirm again that the product has been manually checked and the result matches the <strong>'physical SKU error'</strong>. After submission, the system will automatically move to the next carton.",
  noRfidTag: 'No RFID Tag',
  scanNoResponse: 'Scan No Response',
  physicalSkuCorrectTip:
    'SKU does not belong to this carton number is detected, please check the product packaging and verify that the product SKU is correct. ',
  errorcode_7007: 'This EPC has already been bound to a product. Please remove the RFID tag and relabel by UPC.',
  confirmSubmitNextCarton:
    'Please confirm again. After submission, the system will automatically move to the next carton.',
  manualScanResultInvalidTipFon:
    'The current re-inspection results still differ from the ASN. Please double-check that all products have been scanned and \n' +
    'click on the Confirm button.',
  invalidScanResultTip: 'Gap Info: ',
  manualScanResultInvalidTipBac: 'pieces',
  exceeds: '(Exceeds quantity)',
  missing: '(Missing quantity)',
  cartonCommitSuccess: 'Submit success, the system will automatically proceed to the next Carton. ',
  noRoundScanData: 'No EPC info collected, please scan again.',
  labelTips: 'Please select a reason for relabel:',
  noExistInCarton: 'The SKU does not exist in this carton.',
  errorcode_9000: 'Only the QR code in the picture below is supported.',
  errorcode_9001: 'Only the QR code in the picture below is supported.',
  errorcode_9002: 'Only the QR code in the picture below is supported.',
  errorcode_604: 'The carton is cancelled in wave run list.'
}
